/*
 * @Author: RYL
 * @Description: 
 * @Date: 2020-05-20 14:30:34
 * @LastEditTime: 2021-03-04 15:18:04
 */
//多个组件的混入属性(基本上所有的有表格的页面都需要的属性与方法,分页通过后端)
export const PublicComponent = {
  data() {
      return {
          total: 0,
          offset: 1,
          limit: 10,
          changetimer: null,
          // include:['DeviceList','GroupingList', 'Configurationlist', 'HangingDevice', 'Onlinerate', 
          // 'Flowstatistics', 'Signalstatistics', 'PrinterDriver', 'PrinterDriver', 'Authoritymanagement', 'customermanagement',
          // 'Remoteservice', 'Usercontrol']
          include:['DeviceList','Device','GroupingList', 'Configurationlist', 'HangingDevice', 'Onlinerate', 
                   'Flowstatistics', 'Signalstatistics', 'PrinterDriver', 'PrinterDriver', 'Authoritymanagement', 'customermanagement',
                   'Remoteservice', 'Usercontrol', 'CloudDashboard', 'FastAccess', 'monitorDeviceList', 'cloudTerminal']
      }
  },
  methods: {
      SizeChanges(val) {
          this.limit = val
          this.queryKeyword()
      },
      //切换页数
      CurrentChanges(val) {
          this.offset = val
          this.queryKeyword()
      },
      formatter(row, column) {
          console.log(row.address)
      },
      //搜索框禁止选中
      checkboxInit(row, index) {
          if (index == 0) {
              return 0
          } else {
              return 1
          }
      },
      //添加缓存页面
      AddKeepAlive(Router){
        this.include.push(Router)
      },
      //删除缓存页面
      DeleteKeepAlive(Router){
        this.include.forEach((val,index)=>{
          if(val==Router){
            this.include.splice(index,1)
          }
        })
      }
  },
  watch: {
      //监听设备查询输入框
      seek: {
          handler(newValue, oldValue) {
            this.offset = 1
              //表格搜索框函数防抖
              if (newValue) {
                  if (this.changetimer !== null) {
                      clearTimeout(this.changetimer)
                  }
                  this.changetimer = setTimeout(() => {
                      this.queryKeyword()
                  }, 500)
              }
          },
          deep: true
      },
      //监听表格排序按钮
      sort: {
          handler(newValue, oldValue) {
            this.offset = 1
              if (newValue) {
                  this.queryKeyword()
              }
          },
          deep: true
      }
  }
}
